import Swiper from 'swiper';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';
import { $Elements, BrowserEvents, Classes, Elements, TransitionDurations } from './constants';

//=================================
//	!---------- MENU ----------
//=================================

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Toggle ----------

		$('.menu-toggle, .menu-logo, a[href="#menu-wrapper"]').on('click touchstart', async e => {
			e.preventDefault();

			if($Elements.body.hasClass(Classes.menuOpen)) {
				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll(Elements.MenuWrapper);
			}
			else {

				$('.menu-slider').each(function() {

					if(this.swiper) {
						this.swiper.slideTo(Elements.MenuWrapper.dataset.activeMenu, 0);
					}
				});

				$Elements.body.addClass(Classes.menuOpen);
				disableBodyScroll(Elements.MenuWrapper);
			}
		});

		$('.menu-slider').each(function() {

			if(!this.swiper) {

				const images = $(this).parent().find('.menu-images');
				const pagination = $(this).find('.pagination .current');

				const swiper = new Swiper(this, {
					loop: true,
					slidesPerView: 'auto',
					slideToClickedSlide: true,
					preventInteractionOnTransition: true,
					mousewheel: true,
					resistance: false,
					threshold: 10,
					speed: TransitionDurations.default,
					observer: true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						type: 'progressbar',
					},
					navigation: {
						nextEl: this.querySelector('.next'),
						prevEl: this.querySelector('.prev'),
					},
					on: {
						slideChange: () => {

							const active = swiper.slides[swiper.activeIndex];

							images.find('.menu-image').removeClass(Classes.active);
							images.find('.menu-image[data-menu-item="' + active.dataset.swiperSlideIndex + '"]').addClass(Classes.active);
							pagination.find('.item').removeClass(Classes.active);
							pagination.find('.item[data-menu-item="' + active.dataset.swiperSlideIndex + '"]').addClass(Classes.active);
						}
					}
				});
			}
		});
	});

}(jQuery));
